export default __webpack_public_path__ + "static/benifitImg-f671bbce8f7035b35bfdb5a0246f6ca8.png";